import { render, staticRenderFns } from "./CancelledOrdersTable.vue?vue&type=template&id=245d7105&scoped=true"
import script from "./CancelledOrdersTable.vue?vue&type=script&lang=js"
export * from "./CancelledOrdersTable.vue?vue&type=script&lang=js"
import style0 from "./CancelledOrdersTable.vue?vue&type=style&index=0&id=245d7105&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245d7105",
  null
  
)

export default component.exports